export { default } from './MenuItem';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/MenuItem/index.js
// module id = 336
// module chunks = 0